/* global window:true */

import React, { Component, PropTypes } from 'react';
import Helmet from 'react-helmet';
import ReactGA from 'react-ga';

import Loading from '../components/Loading';

const TITLE = 'Resources manage';

class ResourcesManagePage extends Component {
    componentDidMount() {
        const { actions } = this.props;

        // set breadcrumb
        actions.setBreadcrumb([{ title: TITLE }]);

        // load resources
        actions.ownResourcesRequest();

        // log analytics
        ReactGA.pageview(window.location.pathname);
    }

    render() {
        const { resources, resourcesState } = this.props;
        // console.log('resources', resources);

        if (resourcesState.isFetching && resources.length === 0) {
            return <Loading />;
        }

        return (
            <div className="portfolio-wrapper index-1">
                <Helmet title={TITLE} />
                <div className="section-name index-1 container">
                    <div className="col-md-12 resources-title">
                        <h1>Manage resources</h1>
                        <div className="sep" />
                    </div>
                </div>

                <div className="portfolio-main container" style={{ marginBottom: '140px' }}>
                    {resources.length === 0 ?
                        <p>No books found</p>
                        :
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>Title</th>
                                    <th>Created on</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {resources.map(resource => (
                                    <tr key={resource.id} >
                                        <td>{resource.title}</td>
                                        <td>{resource.create_time}</td>
                                        <td>
                                            <a>edit</a> | <a>delete</a>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    }
                </div>
            </div>
        );
    }
}

ResourcesManagePage.propTypes = {
    actions: PropTypes.object,
    resourcesState: PropTypes.object,
    resources: PropTypes.array
};

export default ResourcesManagePage;



/** WEBPACK FOOTER **
 ** ./src/pages/ResourcesManagePage.js
 **/